module.exports = __webpack_public_path__ + "static/the_wretched-ae2334bcf4d7f6ee7065eaf05dd329ac.png";